import { render, staticRenderFns } from "./FormCategoryAnswer.vue?vue&type=template&id=7cefefa6&scoped=true"
import script from "./FormCategoryAnswer.vue?vue&type=script&lang=js"
export * from "./FormCategoryAnswer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cefefa6",
  null
  
)

export default component.exports